module.exports = __webpack_public_path__ + "40ff29f55f692b13314eb670299e8d91.svg"